import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/pictos/header/chevron_up.svg")